import React from 'react';
import PropTypes from 'prop-types';

const Macro = ({
  value,
  sample,
  onMacrosChange,
  checked
}) => (
  <tr
    onClick={onMacrosChange(value)}
    className="-wa-edit-controls__macros-table-row -wa-edit-controls__macros-table-row__separated"
  >
    <td className="-wa-edit-controls__macros-table-checkbox">
      <input
        type="checkbox"
        value={value}
        checked={checked}
      />
    </td>
    <td className="-wa-edit-controls__macros-table-macros-name">
      <div className="-wa-edit-controls__macros-table-macros-name-cropper">
        <div>
          <span className="-wa-edit-controls__macros-table-macros-name-label">
            {value}
          </span>
        </div>
      </div>
    </td>
    <td className="-wa-edit-controls__macros-table-sample">
      <div className="-wa-edit-controls__macros-table-sample-cropper">{sample}</div>
    </td>
  </tr>
);


Macro.propTypes = {
  value: PropTypes.string.isRequired,
  sample: PropTypes.string.isRequired,
  onMacrosChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired
};

export default Macro;
